<template>
  <div>
    <div class="line_block_bg">
      <div style="font-weight: bold">数据档案->{{ name }}</div>
      <div class="search">
        <el-input
          placeholder="输入指标名称关键词"
          prefix-icon="el-icon-search"
          v-model="keyword"
          style="width: 208px"
          @input="searchValue"
        >
        </el-input>
      </div>
    </div>

    <treeTwo :medicalTree="medicalTree" :key="math"></treeTwo>

    <div class="medicalTree_null" v-if="medicalTree.length == 0">
      <a-empty :image="simpleImage" />
    </div>

    <a-modal
      :visible="visible"
      :title="visibleName"
      @cancel="visible = false"
      :footer="null"
      cancelText="关闭"
      width="800px"
      wrapClassName="medicalVisible"
    >
      <div class="modalCon">
        <div class="popupHeader">
          <div class="">
            <el-select
              v-model="selectVal"
              placeholder="请选择"
              @change="changeSelect"
            >
              <el-option
                v-for="item in selectArrList"
                :key="item.id"
                :label="item.showName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="value">当前值：{{ visibleNewVal }}</div>
        </div>

        <el-table
          :data="visibleTableDate"
          border
          style="width: 100%"
          :loading="loading"
        >
          <el-table-column prop="createTime" label="时间" align="center">
            <template slot-scope="scope">
              {{
                scope.row.createTime
                  ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="value" label="值" align="center">
            <template slot-scope="scope">
              {{ scope.row.value || "-" }}
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="visiblePage.pageNum"
          :page-size="visiblePage.pageSize"
          :total="visiblePage.total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </a-modal>
  </div>
</template>

<script>
import treeTwo from "./treeTwo.vue";
import { EventBus } from "./medicalBus.js";
import moment from "moment";
// import { mapState } from "vuex";
// import { Empty } from "ant-design-vue";
// import { getHistory } from "@/common/api/api.js";
import * as API_Member from "@/api/member/member";

export default {
  props: {
    name: {
      type: String,
    },
  },
  // inject: ["getSelectMemberId"],
  data() {
    return {
      medicalTree: [],
      math: 1,
      keyword: "",

      // userType: this.$store.state.user.user.type, //用户类型
      // userId: this.$store.state.user.user.userId, //用户id
      memberId: this.$route.query.id,
      visible: false,
      visibleName: "",
      visibleNewVal: "",
      selectVal: null,
      selectArrList: [],
      visibleTableDate: [],
      loading: false,
      visiblePage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  components: {
    treeTwo,
  },
  watch: {
    // memberId(curVal, oldVal) {
    //   if (curVal) {
    //     this.memberId = curVal;
    //     this.pageNum = 1;
    //     this.getList();
    //   }
    // },
    name(curVal, oldVal) {
      if (curVal) {
        // this.memberId = curVal;
        this.pageNum = 1;
        this.getList();
      }
    },
  },
  computed: {
    // memberId() {
    //   return this.getSelectMemberId();
    // },
  },
  mounted() {
    this.getList();

    EventBus.$on("TreeOne_node", (value) => {
      // console.log("收到孙子的数据:", value);
      this.visible = true;
      this.visibleName = value.showName;
      this.getSelectList(value);
    });
  },
  beforeDestroy() {
    EventBus.$off("TreeOne_node");
  },
  methods: {
    moment,

    ////////////////////////////////////////弹窗-start
    // 弹窗请求下拉列表
    getSelectList(e) {
      const params = {
        id: e.id,
      };
      API_Member.getList(params).then((res) => {
        if (res.code == 200) {
          if (res.data && res.data.length > 0) {
            this.selectVal = res.data[0].id;
            this.selectArrList = res.data;
            this.loading = true;
            this.getListInfo(res.data[0].id);
            this.getNewListInfo(res.data[0].id);
          }
        }
      });
      // this.$axios.get("/sys/project/getList", params).then((res) => {
      //   if (res.code == 200) {
      //     if (res.data && res.data.length > 0) {
      //       this.selectVal = res.data[0].id;
      //       this.selectArrList = res.data;
      //       this.loading = true;
      //       this.getListInfo(res.data[0].id);
      //       this.getNewListInfo(res.data[0].id);
      //     }
      //   }
      // });
    },

    // 下拉选择变更
    changeSelect(e) {
      this.selectVal = e;
      this.loading = true;
      this.getListInfo(e);
      this.getNewListInfo(e);
    },

    // 通过弹窗下拉获取列表数据
    getListInfo(eid) {
      const params = {
        id: eid,
        memberId: this.memberId,
        pageSize: this.visiblePage.pageSize,
        pageNum: this.visiblePage.pageNum,
      };
      API_Member.getListInfo(params).then((res) => {
        if (res.code == 200) {
          // console.log("getListInfo");
          // console.log(res.data.list);
          this.loading = false;
          if (res.data && res.data.list.length > 0) {
            this.visibleTableDate = res.data.list;
            this.visiblePage.total = res.data.total;
          }
        }
      });
      // this.$axios.get("/sys/project/getListInfo", params).then((res) => {
      //   if (res.code == 200) {
      //     // console.log("getListInfo");
      //     // console.log(res.data.list);
      //     this.loading = false;
      //     if (res.data && res.data.list.length > 0) {
      //       this.visibleTableDate = res.data.list;
      //       this.visiblePage.total = res.data.total;
      //     }
      //   }
      // });
    },

    // 通过弹窗下拉获取最新的一个值
    getNewListInfo(eid) {
      const params = {
        id: eid,
        memberId: this.memberId,
      };
      API_Member.getNewListInfo(params).then((res) => {
        if (res.code == 200) {
          // console.log("getNewListInfo");
          // console.log(res.data);
          if (res.data) {
            this.visibleNewVal = res.data;
          }
        }
      });
      // this.$axios.get("/sys/project/getNewListInfo", params).then((res) => {
      //   if (res.code == 200) {
      //     // console.log("getNewListInfo");
      //     // console.log(res.data);
      //     if (res.data) {
      //       this.visibleNewVal = res.data;
      //     }
      //   }
      // });
    },

    // 弹窗分页切换-start
    handleSizeChange(val) {
      console.log(val);
      this.visiblePage.pageSize = val;
      this.getListInfo();
    },

    handleCurrentChange(val) {
      console.log(val);
      this.visiblePage.pageNum = val;
      this.getListInfo();
    },
    // 弹窗分页切换-end

    ////////////////////////////////////////弹窗-end

    // 搜索
    searchValue(e) {
      console.log(e);
      this.medicalTree = [];
      this.getList();
    },

    // 获取右侧主内容列表
    getList() {
      const params = {
        showName: this.name,
        memberId: this.userType != 2 ? this.memberId : this.userId,
        orxxxName: this.keyword || "",
      };
      API_Member.getTreeInfo(params).then((res) => {
        if (res.code == 200) {
          this.medicalTree = [];

          if (res.data && res.data.length > 0) {
            if (res.data[0].children && res.data[0].children.length > 0) {
              this.math = this.math++;
              this.medicalTree = res.data[0].children;
            } else {
              this.medicalTree = [];
            }
          } else {
            this.medicalTree = [];
          }
        }
      });
    },
  },
  filters: {},
};
</script>
<style scoped lang="less">
.line_block_bg {
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 10px 0 10px 15px;
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 15px;
}

.search {
  margin-left: auto;
  padding-right: 15px;
}
.medicalTree_null {
  width: 100%;
  display: inline-block;
  margin: 60px auto 30px;
  .ant-empty-image {
    height: auto;
  }
}
.modalCon {
  .popupHeader {
    display: flex;
    align-items: center;
    color: #fff;
    margin-bottom: 22px;
    .value {
      margin-left: 30px;
    }
  }
}
::v-deep .medicalVisible {
  .el-pagination {
    width: 100%;
    text-align: center;
    display: inline-block;
    margin: 20px auto 15px;
  }
  .el-pager li {
    background-color: #21284b;
    border: 1px solid #21284b;
    color: #fff;
    &.active {
      background-color: #1890ff;
      border: 1px solid #1890ff;
    }
    &:hover {
      border: 1px solid #1890ff;
    }
  }
  .el-pagination {
    .btn-prev,
    .btn-next {
      background-color: #21284b;
      color: #fff;
      &:hover {
        background-color: #1890ff;
      }
    }
  }
}
</style>
